/**
 * The largest single file a person may upload: 500 MiB (524288000 bytes).
 *
 * ONE number for every wall (spec 2026-09-24, Part A): the composer's
 * pick-time refusal (web AttachmentHandler), the server's confirm-upload
 * refusal (file-storage.service re-exports this), and the `uploads` bucket's
 * `file_size_limit` (a server unit test reads the newest bucket migration and
 * asserts it equals this). The project-wide Storage limit is a Supabase
 * DASHBOARD setting, not code: it must be 500 MB on staging and prod, or it
 * governs instead.
 */
export const UPLOAD_MAX_BYTES = 500 * 1024 * 1024;

/**
 * The largest file that reaches the box BY BYTES: 50 MiB (52428800 bytes).
 *
 * Only video and audio go to the box by reference (a signed url the box
 * streams itself), bounded by UPLOAD_MAX_BYTES. Everything else (documents,
 * archives, images sent as files) is downloaded whole by the one-replica
 * server and written to the volume, so this number is that process's heap
 * budget, not a storage policy. The server's sync refuses past it
 * (attachment-guard's MAX_ATTACHMENT_BYTES re-exports it), and the web's
 * picker refuses the same file at pick time with the same number, instead of
 * after a silent upload (final review I2).
 */
export const ATTACHMENT_BYTE_PATH_MAX_BYTES = 50 * 1024 * 1024;

/**
 * How many files one message, or one file answer on the ask card, carries.
 * The server's sync and the resolve route refuse past it; the ask card never
 * stages more (final review M1).
 */
export const MAX_ATTACHMENTS = 20;
